import { render, staticRenderFns } from "./goodsInfo.vue?vue&type=template&id=4dfc008e&scoped=true"
import script from "./goodsInfo.vue?vue&type=script&lang=js"
export * from "./goodsInfo.vue?vue&type=script&lang=js"
import style0 from "./goodsInfo.vue?vue&type=style&index=0&id=4dfc008e&prod&lang=less"
import style1 from "./goodsInfo.vue?vue&type=style&index=1&id=4dfc008e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfc008e",
  null
  
)

export default component.exports